export const rptConstants = {
    RPT_RESET: 'RPT_RESET',
    RPT_FETCH_COMPLETED: 'RPT_FETCH_COMPLETED',   
    RPT_SET_DATA: 'RPT_SET_DATA',
    RPT_DELETE_DATA: 'RPT_DELETE_DATA'
};